'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useMattersStore } from '@repo/store/useMattersStore'
import { MatterSearchResultCard } from '@repo/ui/MatterSearchResultCard'

export const MatterSelectByClient = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  clientNo = '',
  errors = {},
  name = 'matterNo'
}) => {
  const { fetchMatterByClientNo, relatedMatters, currentClientMatterNo } = useMattersStore()
  const [gotOptions, setGotOptions] = useState(false)
  const [options, setOptions] = useState(testData || relatedMatters || [])

  useEffect(() => {
    setGotOptions(false)
  }, [clientNo])

  useEffect(() => {
    if (testData) return
    setOptions(relatedMatters || [])
  }, [testData, relatedMatters])

  useEffect(() => {
    if (testData || !clientNo || gotOptions) return
    fetchMatterByClientNo({ clientNo })
    setGotOptions(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, relatedMatters, clientNo, gotOptions])

  return (
    <div
      data-testid="MatterSelectByClient"
      style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}
    >
      <ReactSelectMenu
        label="Matter"
        onChange={onChange}
        labelKey="description"
        valueKey="clientMatterNo"
        disabled={!clientNo}
        items={options}
        value={value}
        searchable
        idLabelKey="clientMatterNo"
        showIdInResults={false}
        name={name}
        size={size}
        required={required}
        errors={errors}
        valueCustomRenderFunction={(matter) => {
          return (
            <MatterSearchResultCard
              matter={matter}
              currentClientMatterNo={currentClientMatterNo}
              isListOption={false}
            />
          )
        }}
        optionCustomRenderFunction={(matter) => {
          return <MatterSearchResultCard matter={matter} currentClientMatterNo={currentClientMatterNo} />
        }}
      />
    </div>
  )
}

MatterSelectByClient.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  clientNo: PropTypes.string,
  errors: PropTypes.object,
  name: PropTypes.string
}
